// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.property.enums.RentalManagerLaundryType

export enum RentalManagerLaundryType {
  HOOKUPS = 'HOOKUPS',
  IN_UNIT = 'IN_UNIT',
  NONE = 'NONE',
  SHARED = 'SHARED',
}

export const RentalManagerLaundryType_values = [
  RentalManagerLaundryType.HOOKUPS,
  RentalManagerLaundryType.IN_UNIT,
  RentalManagerLaundryType.NONE,
  RentalManagerLaundryType.SHARED,
] as const;
